import { FC, useEffect, useRef, useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import Jumbotron from "../components/jumbotron";
import ScreenBase from "./ScreenBase";
import YouTubeEmbed from "../components/youTubeEmbed";
import useGetCollection from "../hooks/getCollection";
import BlogPost from "../models/blogPost";
import BlogPostFeatured from "../components/blogPostFeatured";
import BlogPostCard from "../components/blogPostCard";

type Props = {};

const HomeScreen: FC<Props> = () => {
	const youtubeContainerRef = useRef<HTMLDivElement>(null);
	const [embedHeight, setEmbedHeight] = useState<number>(300); // Default height
	const { data: blogData, loading } = useGetCollection<BlogPost[]>('/blogPost/published');

	const [featuredBlogs, setFeaturedBlogs] = useState<BlogPost[]>([]);
	const [standardBlogs, setStandardBlogs] = useState<BlogPost[]>([]);

	useEffect(() => {
		const updateHeight = () => {
			if (youtubeContainerRef.current) {
				const width = youtubeContainerRef.current.clientWidth;
				setEmbedHeight(width / 1.77); // Update the height based on the aspect ratio
			}
		};

		// Initial height calculation
		updateHeight();

		// Recalculate height on window resize
		window.addEventListener('resize', updateHeight);
		return () => window.removeEventListener('resize', updateHeight);
	}, []);

	useEffect(() => {
		if (blogData?.length) {
			const featured = blogData.filter(blog => blog.featured);
			const standard = featured?.length ? blogData.filter(blog => !blog.featured).slice(0, 3) : blogData.slice(1, 4);

			setFeaturedBlogs(featured?.length ? featured : [blogData[0]]);
			setStandardBlogs(standard);
		}
	}, [blogData]);

	return (
		<ScreenBase
			scrollableChildren={(
				<Stack>
					<Box
						component="section"
						sx={{
							display: { xs: 'block', sm: 'block', md: 'none', lg: 'none', xl: 'none' },
							mb: { xs: 2, sm: 2, md: 0, lg: 0, xl: 0 }
						}}
					>
						<Box><Typography variant="button" color="textPrimary" sx={{ opacity: 0.7 }}>Welcome to</Typography></Box>
						<Box><Typography variant="h5" color="textPrimary">TIM KULIG FREE MUSIC</Typography></Box>
					</Box>
					<Box component="section" mb={4}>
						<Jumbotron size={240} />
					</Box>
					<Box
						component="section"
						sx={{
							display: { xs: 'none', sm: 'none', md: 'block', lg: 'block', xl: 'block' },
							mb: { xs: 0, sm: 0, md: 4, lg: 4, xl: 4 }
						}}
					>
						<Box><Typography variant="button" color="textPrimary" sx={{ opacity: 0.7 }}>Welcome to</Typography></Box>
						<Box><Typography variant="h4" color="textPrimary">TIM KULIG FREE MUSIC</Typography></Box>
					</Box>
					<Stack component="section" spacing={4}>
						{!loading && featuredBlogs.length && featuredBlogs.map((blog, index) => (
							<BlogPostFeatured blogPost={blog} />
						))}
						{!loading && standardBlogs.length && (
							<Stack direction="row" gap={3} flexWrap="wrap">
								{standardBlogs.map((blog, index) => (
									<BlogPostCard key={`blogCard-${blog.id}`} blogPost={blog} />
								))}
							</Stack>
						)}
					</Stack>
					<Stack component="section" spacing={2} pt={13} pb={6}>
						{/* <Typography variant="h6" color="textSecondary">Something</Typography> */}
						<Box ref={youtubeContainerRef}>
							<YouTubeEmbed playlistId="PLHmC6i_6Ddvn9QWaDRHePobmJ27zSuXos" width="100%" height={embedHeight} />
						</Box>
					</Stack>
				</Stack>
			)}
		/>
	);
};

export default HomeScreen;